import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0bdaec6a&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=0bdaec6a&prod&scoped=true&lang=css"
import style1 from "@/styles/list.scss?vue&type=style&index=1&id=0bdaec6a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdaec6a",
  null
  
)

export default component.exports